export default {
  currentMedKeyTypeName: null
};
